import React from 'react'

import EmptyState from '../../../shares/components/EmptyStateOld'
import DocumentListEmptyState from '../../../shares/components/DocumentListEmptyState'

const TITLE = 'Trash is empty'

interface TrashListEmptyStateProps {
  search?: string
}

const TrashListEmptyState = ({ search }: TrashListEmptyStateProps) => {
  if (search) {
    return (
      <EmptyState
        title={TITLE}
        description="Documents and folders in Trash are permanently deleted after 90 days."
        search={search}
      />
    )
  }

  return (
    <DocumentListEmptyState
      title={TITLE}
      description="Move any unwanted documents or folders here."
    />
  )
}

export default TrashListEmptyState
